import React from 'react'

import ReactDOM from 'react-dom/client'
import { worker } from 'mocks/browser'
import DarkModeLoader from 'components/DarkModeLoader'

import reportWebVitals from './reportWebVitals'
import { ApplicationProvider } from './context/application'
import Home from './pages/Home'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

if (process.env.NODE_ENV === 'development') {
  worker.start()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <>
    <DarkModeLoader />
    <ApplicationProvider>
      <Home />
    </ApplicationProvider>
  </>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
